export const messages = {
  en: {
    shops: {
      floorUnitTree: {
        all: 'All',
        noData: 'No locations'
      },
      queryCondition: 'Query Conditions',
      ownerNamePlaceholder: 'Owner/Tenant Name',
      linkPlaceholder: 'Contact Number',
      rentStartPlaceholder: 'Start Date',
      rentEndPlaceholder: 'End Date',
      rentTime: 'Rent Date',
      shopInfo: 'Shop Information',
      shopId: 'Shop ID',
      shopIdPlaceholder: 'Please enter shop ID',
      shopNumber: 'Shop Number',
      shopNumberPlaceholder: 'Please enter shop number',
      state: 'Status',
      statePlaceholder: 'Please select status',
      rented: 'Rented',
      sold: 'Sold',
      idle: 'Vacant',
      addShop: 'Add Shop',
      floor: 'Floor',
      owner: 'Owner/Tenant',
      contactNumber: 'Contact Number',
      builtUpArea: 'Built-up Area',
      usedArea: 'Used Area',
      roomArea: 'Indoor Area',
      startTime: 'Start Lease Time',
      endTime: 'End Lease Time',
      rent: 'Rent',
      sell: 'Sell',
      feeCoefficient: 'Fee Coefficient',
      operation: 'Operation',
      rentAction: 'Rent',
      sellAction: 'Sell',
      unbind: 'Unbind',
      edit: 'Edit',
      delete: 'Delete',
      squareMeter: 'm²',
      layerUnit: 'F',
      confirmDelete: 'Confirm Delete',
      deleteTip: 'Deleting the shop will delete associated fees and payment records, and automatically unbind the owner!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      building: 'Building',
      tenantPhone: 'Tenant Phone',
      tenantName: 'Tenant Name',
      leaseStart: 'Lease Start Date',
      leaseEnd: 'Lease End Date',
      remark: 'Remark',
      shopFloor: 'Shop Floor',
      feeCoefficientPlaceholder: 'Please enter fee coefficient',
      builtUpAreaPlaceholder: 'Please enter built-up area',
      roomAreaPlaceholder: 'Please enter indoor area',
      rentPlaceholder: 'Please enter rent amount',
      shopNumberRequired: 'Shop number is required',
      floorRequired: 'Shop floor is required',
      buildingRequired: 'Building is required',
      rentRequired: 'Rent is required',
      builtUpAreaRequired: 'Built-up area is required',
      usedAreaRequired: 'Used area is required',
      roomAreaRequired: 'Indoor area is required',
      feeCoefficientRequired: 'Fee coefficient is required',
      tenantPhoneRequired: 'Tenant phone is required',
      tenantNameRequired: 'Tenant name is required',
      leaseStartRequired: 'Lease start date is required',
      leaseEndRequired: 'Lease end date is required',
      phoneFormatError: 'Invalid phone format',
      shopLocation: 'Shop Location',
      location: 'Location',
      locationName: 'Location Name',
      parentLocation: 'Parent Location',
      seq: 'Sequence',
      addLocation: 'Add Location',
      editLocation: 'Edit Location',
      locationNameRequired: 'Location name is required',
      shopArea: 'Shop Area',
      editShop: 'Edit Shop',
      deleteConfirmMsg: 'Are you sure you want to delete this shop?',
      locationRequired: 'Please select location',
      search: 'Search',
      reset: 'Reset',
      topLevel: 'Top Level',
      addChildLocation: 'Add Child Location',
      deleteLocation: 'Delete Location',
      deleteLocationConfirmMsg: 'Are you sure you want to delete this location?',
      pleaseSelectLocation: 'Please select a location first',
      importShop: {
        title: 'Shop Import',
        selectFile: 'Select File',
        clickUpload: 'Click to upload',
        requiredFile: 'Required, please select data file',
        downloadTemplate: 'Download Template',
        downloadFirst: 'Please download first',
        shopTemplate: 'Shop Template',
        prepareData: 'to prepare data, then upload for import',
        fileRequired: 'File cannot be empty',
        invalidFormat: 'Invalid Excel format',
        fileSizeExceeded: 'Excel file size cannot exceed 2MB',
        button: 'Import Shop'
      },
      handOver: 'Hand Over',
      checkOut: 'Check Out',
      rentShop: 'Rent Shop',
      sellShop: 'Sell Shop',
      leaseType: 'Lease Type',
      leasePeriod: 'Lease Period',
      leaseTypePlaceholder: 'Please select lease type',
      selectOwner: 'Select Owner',
      startTimePlaceholder: 'Select start time',
      endTimePlaceholder: 'Select end time',
      remarkPlaceholder: 'Please enter remark',
      shopIdRequired: 'Shop ID is required',
      timeError: 'Start time must be before end time',
      confirmCheckOut: 'Confirm Check Out',
      checkOutRemarkPlaceholder: 'Please enter check out remark',
      checkOutError: 'Shop ID and Owner ID are required for check out'
    }
  },
  zh: {
    shops: {
      floorUnitTree: {
        all: '全部',
        noData: '暂无位置'
      },
      queryCondition: '查询条件',
      ownerNamePlaceholder: '业主/租方名称',
      linkPlaceholder: '联系电话',
      rentStartPlaceholder: '开始日期',
      rentEndPlaceholder: '结束日期',
      rentTime: '出租时间',
      shopInfo: '商铺信息',
      shopId: '商铺ID',
      shopIdPlaceholder: '请填写商铺ID',
      shopNumber: '商铺编号',
      shopNumberPlaceholder: '请输入商铺编号',
      state: '状态',
      statePlaceholder: '请选择状态',
      rented: '已出租',
      sold: '已出售',
      idle: '空闲',
      addShop: '添加商铺',
      floor: '楼层',
      owner: '业主/租方',
      contactNumber: '联系电话',
      builtUpArea: '建筑面积',
      usedArea: '使用面积',
      roomArea: '室内面积',
      startTime: '起租时间',
      endTime: '截租时间',
      rent: '租金',
      sell: '出售',
      feeCoefficient: '算费系数',
      operation: '操作',
      rentAction: '出租',
      sellAction: '出售',
      unbind: '解绑',
      edit: '修改',
      delete: '删除',
      squareMeter: '平方米',
      layerUnit: '层',
      confirmDelete: '确认删除',
      deleteTip: '确认是否删除!删除房屋会关联删除房屋下的费用以及缴费记录，并且自动解绑业主！',
      cancel: '取消',
      confirm: '确认',
      save: '保存',
      building: '楼栋',
      tenantPhone: '租户手机号',
      tenantName: '租户姓名',
      leaseStart: '起租时间',
      leaseEnd: '截租时间',
      remark: '备注',
      shopFloor: '商铺楼层',
      feeCoefficientPlaceholder: '请填写算费系数',
      builtUpAreaPlaceholder: '请填写建筑面积',
      roomAreaPlaceholder: '请填写室内面积',
      rentPlaceholder: '请填写租金',
      shopNumberRequired: '商铺编号不能为空',
      floorRequired: '商铺楼层不能为空',
      buildingRequired: '楼栋不能为空',
      rentRequired: '租金不能为空',
      builtUpAreaRequired: '建筑面积不能为空',
      usedAreaRequired: '使用面积不能为空',
      roomAreaRequired: '室内面积不能为空',
      feeCoefficientRequired: '算费系数不能为空',
      tenantPhoneRequired: '租户手机号不能为空',
      tenantNameRequired: '租户名称不能为空',
      leaseStartRequired: '起租时间不能为空',
      leaseEndRequired: '截租时间不能为空',
      phoneFormatError: '手机号格式错误',
      shopLocation: '商铺位置',
      location: '位置',
      locationName: '位置名称',
      parentLocation: '上级位置',
      seq: '排序',
      addLocation: '添加位置',
      editLocation: '修改位置',
      locationNameRequired: '位置名称不能为空',
      shopArea: '商铺面积',
      editShop: '修改商铺',
      deleteConfirmMsg: '确定要删除此商铺吗？',
      locationRequired: '请选择位置',
      search: '查询',
      reset: '重置',
      topLevel: '顶级',
      addChildLocation: '添加下级位置',
      deleteLocation: '删除位置',
      deleteLocationConfirmMsg: '确定要删除此位置吗？',
      pleaseSelectLocation: '请先选择一个位置',
      importShop: {
        title: '商铺导入',
        selectFile: '选择文件',
        clickUpload: '点击上传',
        requiredFile: '必填，请选择数据文件',
        downloadTemplate: '下载模板',
        downloadFirst: '请先下载',
        shopTemplate: '商铺模板',
        prepareData: '准备数据后，上传导入',
        fileRequired: '文件不能为空',
        invalidFormat: '不是有效的Excel格式',
        fileSizeExceeded: 'Excel文件大小不能超过2M',
        button: '导入商铺'
      },
      handOver: '交铺',
      checkOut: '退铺',
      rentShop: '出租商铺',
      sellShop: '出售商铺',
      leaseType: '租赁类型',
      leasePeriod: '租期',
      leaseTypePlaceholder: '请选择租赁类型',
      selectOwner: '选择业主',
      startTimePlaceholder: '请选择开始时间',
      endTimePlaceholder: '请选择结束时间',
      remarkPlaceholder: '请输入备注',
      shopIdRequired: '商铺ID不能为空',
      timeError: '开始时间必须早于结束时间',
      confirmCheckOut: '确认退铺',
      checkOutRemarkPlaceholder: '请输入退铺备注',
      checkOutError: '退铺需要商铺ID和业主ID'
    }
  },
  'zh-TW': {
    shops: {
      floorUnitTree: {
        all: '全部',
        noData: '暫無位置'
      },
      queryCondition: '查詢條件',
      ownerNamePlaceholder: '業主/租方名稱',
      linkPlaceholder: '聯繫電話',
      rentStartPlaceholder: '開始日期',
      rentEndPlaceholder: '結束日期',
      rentTime: '出租時間',
      shopInfo: '商鋪信息',
      shopId: '商鋪ID',
      shopIdPlaceholder: '請填寫商鋪ID',
      shopNumber: '商鋪編號',
      shopNumberPlaceholder: '請輸入商鋪編號',
      state: '狀態',
      statePlaceholder: '請選擇狀態',
      rented: '已出租',
      sold: '已出售',
      idle: '空閒',
      addShop: '添加商鋪',
      floor: '樓層',
      owner: '業主/租方',
      contactNumber: '聯繫電話',
      builtUpArea: '建築面積',
      usedArea: '使用面積',
      roomArea: '室內面積',
      startTime: '起租時間',
      endTime: '截租時間',
      rent: '租金',
      sell: '出售',
      feeCoefficient: '算費係數',
      operation: '操作',
      rentAction: '出租',
      sellAction: '出售',
      unbind: '解綁',
      edit: '修改',
      delete: '刪除',
      squareMeter: '平方米',
      layerUnit: '層',
      confirmDelete: '確認刪除',
      deleteTip: '確認是否刪除!刪除房屋會關聯刪除房屋下的費用以及繳費記錄，並且自動解綁業主！',
      cancel: '取消',
      confirm: '確認',
      save: '保存',
      building: '樓棟',
      tenantPhone: '租戶手機號',
      tenantName: '租戶姓名',
      leaseStart: '起租時間',
      leaseEnd: '截租時間',
      remark: '備註',
      shopFloor: '商鋪樓層',
      feeCoefficientPlaceholder: '請填寫算費係數',
      builtUpAreaPlaceholder: '請填寫建築面積',
      roomAreaPlaceholder: '請填寫室內面積',
      rentPlaceholder: '請填寫租金',
      shopNumberRequired: '商鋪編號不能為空',
      floorRequired: '商鋪樓層不能為空',
      buildingRequired: '樓棟不能為空',
      rentRequired: '租金不能為空',
      builtUpAreaRequired: '建築面積不能為空',
      usedAreaRequired: '使用面積不能為空',
      roomAreaRequired: '室內面積不能為空',
      feeCoefficientRequired: '算費係數不能為空',
      tenantPhoneRequired: '租戶手機號不能為空',
      tenantNameRequired: '租戶名稱不能為空',
      leaseStartRequired: '起租時間不能為空',
      leaseEndRequired: '截租時間不能為空',
      phoneFormatError: '手機號格式錯誤',
      shopLocation: '商鋪位置',
      location: '位置',
      locationName: '位置名稱',
      parentLocation: '上級位置',
      seq: '排序',
      addLocation: '添加位置',
      editLocation: '修改位置',
      locationNameRequired: '位置名稱不能為空',
      shopArea: '商鋪面積',
      editShop: '修改商鋪',
      deleteConfirmMsg: '確定要刪除此商鋪嗎？',
      locationRequired: '請選擇位置',
      search: '查詢',
      reset: '重置',
      topLevel: '頂級',
      addChildLocation: '添加下級位置',
      deleteLocation: '刪除位置',
      deleteLocationConfirmMsg: '確定要刪除此位置嗎？',
      pleaseSelectLocation: '請先選擇一個位置',
      importShop: {
        title: '商鋪導入',
        selectFile: '選擇文件',
        clickUpload: '點擊上傳',
        requiredFile: '必填，請選擇數據文件',
        downloadTemplate: '下載模板',
        downloadFirst: '請先下載',
        shopTemplate: '商鋪模板',
        prepareData: '準備數據後，上傳導入',
        fileRequired: '文件不能為空',
        invalidFormat: '不是有效的Excel格式',
        fileSizeExceeded: 'Excel文件大小不能超過2M',
        button: '導入商鋪'
      },
      handOver: '交鋪',
      checkOut: '退鋪',
      rentShop: '出租商鋪',
      sellShop: '出售商鋪',
      leaseType: '租賃類型',
      leasePeriod: '租期',
      leaseTypePlaceholder: '請選擇租賃類型',
      selectOwner: '選擇業主',
      startTimePlaceholder: '請選擇開始時間',
      endTimePlaceholder: '請選擇結束時間',
      remarkPlaceholder: '請輸入備註',
      shopIdRequired: '商鋪ID不能為空',
      timeError: '開始時間必須早於結束時間',
      confirmCheckOut: '確認退鋪',
      checkOutRemarkPlaceholder: '請輸入退鋪備註',
      checkOutError: '退鋪需要商鋪ID和業主ID'
    }
  }
}